import { useCallback, useEffect, useState } from 'react';

export default function useFetch(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [attempt, setAttempt] = useState(0);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(fetcher, deps);

  useEffect(() => {
    let active = true;
    setIsLoading(true);
    setError(null);

    run()
      .then(result => {
        if (active) setData(result);
      })
      .catch(err => {
        if (active) setError(err);
      })
      .finally(() => {
        if (active) setIsLoading(false);
      });

    return () => {
      active = false;
    };
  }, [run, attempt]);

  const retry = useCallback(() => setAttempt(n => n + 1), []);

  return { data, isLoading, error, retry };
}
